<template>
  <div class="case-details">
    <banner title="案例详情" subtitle="CASE DETAILS" />
    <div class="case-product" v-loading="loading">
      <div class="case-product-content">
        <img v-if="caseIdList.Img" v-lazy="$img(caseIdList.Img)" alt />
        <p class="product-title">{{caseIdList.Title}}</p>
        <p class="product-time">{{formatDate(caseIdList.CreateTime)}}</p>
        <p class="product-content">{{caseIdList.Content}}</p>
        <router-link class="back-link" to="/case">← 返回案例列表</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      loading: true,
      pid: 0,
      caseIdList: {}
    };
  },
  created() {
    this.pid = this.$route.params.id;
  },
  mounted() {
    this.loadData();
  },
  methods: {
    formatDate(value) {
      if (!value) return "";
      const t = new Date(value);
      if (Number.isNaN(t.getTime())) return value;
      const m = `${t.getMonth() + 1}`.padStart(2, "0");
      const d = `${t.getDate()}`.padStart(2, "0");
      return `${t.getFullYear()}-${m}-${d}`;
    },
    loadData() {
      this.loading = true;
      this.$http
        .get(`Case/${this.pid}`)
        .then(response => {
          this.caseIdList = response.data || {};
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.case-details {
  width: 100%;
  background: linear-gradient(180deg, #14679f 0%, #0f4f7d 100%);
  padding-bottom: 40px;

  .case-product {
    width: 1240px;
    max-width: calc(100% - 32px);
    margin: -28px auto 0;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 -8px 30px rgba(8, 28, 46, 0.12);
    position: relative;
    z-index: 1;

    &-content {
      width: 760px;
      max-width: calc(100% - 48px);
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 48px 0 56px;

      img {
        width: 100%;
        height: 400px;
        object-fit: cover;
        border-radius: 12px;
        box-shadow: 0 10px 24px rgba(15, 47, 74, 0.1);
      }

      .product-title {
        margin: 0;
        font-size: 28px;
        color: #17324a;
        padding: 24px 0 8px;
        font-weight: 600;
        line-height: 1.4;
      }

      .product-time {
        margin: 0;
        color: #7a93a8;
        font-size: 13px;
      }

      .product-content {
        margin: 0;
        font-size: 16px;
        font-weight: 400;
        color: #3d5568;
        line-height: 1.9;
        padding: 22px 0 28px;
        white-space: pre-wrap;
      }

      .back-link {
        color: #1f6fab;
        text-decoration: none;
        font-size: 14px;
      }
    }
  }
}

@media (max-width: 720px) {
  .case-product-content {
    padding: 28px 0 36px;
  }

  .case-product-content .product-title {
    font-size: 22px;
  }

  .case-product-content img {
    height: 220px;
  }
}
</style>
